import React,{useState} from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from "js-cookie";
import BaseUrl from '../Components/BaseUrl';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Register = () => {
  const navigate =useNavigate();
    const [formData, setFormData] = useState({
      // name: "",
      email: "",
      password: "",
      c_password: "",
    });
    const [error, setError] = useState({
      // name: "",
      email: "",
      password: "",
      c_password: "",
    })
    const [showPassword, setShowPassword] = useState(false);
    const [showCPassword, setShowCPassword] = useState(false);
    const handleChange = (e) => {
        const {id,value}=e.target;
        setFormData({...formData,[id]:value})
        setError({...error,[id]:""})
    }
    const validateForm=()=>{
        let isValid=true;
        let errors={};
        // if (formData.name.trim() === "") {
        //     errors.name = "Name is required";
        //     isValid = false;
        // }
        if (formData.email.trim() === "") {
            errors.email = "Email is required";
            isValid = false;
        }else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = "Email is invalid!";
          }
        if (formData.password === "") {
            errors.password = "Password is required";
            isValid = false;
        }
        if (formData.confirmPassword === "") {
            errors.c_password = "Confirm Password is required";
            isValid = false;
        }else if(formData.password!==formData.c_password){
            errors.c_password = "Password and Confirm Password should be same";
            isValid = false;
        }
    
        setError(errors);
        return isValid;
    }
    const handleSubmit=async(e)=>{
        e.preventDefault();
        const result=validateForm();
        if(result){
            try {
                const response = await axios.post(BaseUrl+'register',formData)
                
                console.log(response.data.status)
                console.log(response.data.data.id);
                if(response.status===200){
                  Cookies.set("user_id", response.data.data.id, { expires: 1, secure: true, sameSite: "Strict" });
                  
                    Swal.fire({
                        icon: "success",
                        title:"User Registered Successfully!",
                        confirmButtonText:"Done",
                        showConfirmButton:true,
                      })
                      setFormData({
                        email: "",
                        password: "",
                        c_password:""
                      });
                    setTimeout(() => {
                      navigate("/user/onboarding/step1")
                    }, 2000);
                    window.localStorage.setItem("user_id", response.data.data.id); 
                    
                }
            } catch (error) {
                console.log(error)
            }
        }
        }
    
  return (
    <>
      <div className="flex items-center justify-center min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md mt-10">
          <h2 className="text-3xl font-bold mb-6 text-center">Sign Up</h2>
          <form>
            {/* <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="name"
              >
                Name <span className="text-red-500">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                value={formData.name}
                onChange={handleChange}
                type="text"
                placeholder="Name"
              />
              <span className="text-red-500 ml-1 text-sm mb-1">{error.name}</span>
            </div> */}
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="email"
              >
                Email <span className="text-red-500">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="email"
                value={formData.email}
                onChange={handleChange}
                type="text"
                placeholder="Email or phone"
              />
              <span className="text-red-500 ml-1 text-sm mb-1">{error.email}</span>
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="password"
              >
                Password <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="password"
                  vlaue={formData.password}
                  onChange={handleChange}
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                />
                <span className=" absolute cursor-pointer top-3 right-3"  onClick={() => setShowPassword(!showPassword)}>
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye}  />
                </span>
                  
                <span className="text-red-500 ml-1 text-sm mb-1">{error.password}</span>
              </div>
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="password"
              >
                Confirm Password <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="c_password"
                  value={formData.c_password}
                  onChange={handleChange}
                  type={showCPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                />
                <span className=" absolute cursor-pointer top-3 right-3"  onClick={() => setShowCPassword(!showCPassword)}>
                <FontAwesomeIcon icon={showCPassword ? faEyeSlash : faEye}  />
                </span>
                <span className="text-red-500 text-sm ml-1 mb-1">{error.c_password}</span>
              </div>
              
            </div>

            <div className="mb-4 ml-1">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox size-4 text-green-500"
                />
                <span className="ml-2 text-gray-700">Remember me</span>
              </label>
            </div>
            <div className="mb-8  mt-8 flex flex-col items-center">
              <button
                className="bg-[#0A66C2] hover:bg-blue-700 text-white text-LG font-bold py-2 px-4 h-12 rounded-full w-3/4"
                type="button"
                onClick={handleSubmit}
              >
                Agree & Join
              </button>
            </div>
            <div className="flex items-center justify-center mb-4">
              <hr className="w-full border-gray-300" />
              <span className="px-2 text-black">or</span>
              <hr className="w-full border-gray-300" />
            </div>
            <div className="mb-8 mt-8">
              <button
                className="bg-white border border-gray-300 text-[#5E5E5E] font-bold py-2 px-4 rounded-full w-full flex items-center justify-center"
                type="button"
              >
                <img
                  src="/Images/login/google 1.png"
                  alt="Google logo"
                  className="mr-2"
                />
                Continue with Google
              </button>
            </div>
            <div className="text-center">
              <span className="text-gray-700">Already on LS Linkup? </span>
              <Link to="/user/login" className="text-[#0A66C2]">
                Sign In
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Register;
